import { FC } from 'react';
import { Outlet } from 'react-router-dom';

type Props = {
    installNotify?: boolean;
};

const RouterOutlet: FC<Props> = ({ installNotify = true }) => {
    return <Outlet />
}

export default RouterOutlet;